export default "__VITE_ASSET__CVDQBHlO__"